import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import ActiveStepDetails from "../components/planPartials/ActiveStepDetails";
import ScrollToTop from "../components/common/ScrollToTop";
import TopStepsStatus from "../components/planPartials/TopStepsStatus";
import ChoosePlan from "../components/planPartials/ChoosePlan";
import { useGeneral } from "../components/contexts/GeneralContext";
import SelectMeals from "../components/planPartials/SelectMeals";
import SignInStep from "../components/planPartials/SignInStep";
import ChildForm from "../components/planPartials/ChildForm";
import { useStep } from "../components/contexts/SubscriptionContext";
import { useEffect } from "react";
import MealChildManagement from "../components/planPartials/MealChildManagement";

const SubscribeChildDetailsPage = () => {
  const { discountCoupons } = useGeneral();
  const { goToStep } = useStep();
  useEffect(() => {
    goToStep("3.2");
  }, []);
  return (
    <>
      <ScrollToTop />
      <PageWrapper loading={false} className="">
        <Header code={discountCoupons} />
        <BodyWrapper className="">
          <TopStepsStatus rightText={""} url={""} />
          <div className="pt-4 lg:pt-9">
            {/* <ChildForm /> */}
            <MealChildManagement />
          </div>
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default SubscribeChildDetailsPage;
